import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActionSheetController, AlertController, Platform} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {ViewCell} from '../../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'button-view',
  templateUrl: 'button-view.component.html',
  styleUrls: ['./button-view.component.scss']
})
export class ButtonViewComponent implements ViewCell {

  renderValue: string;
  isButton: boolean;
  visible = true;
  hiddenSelect = true;
  isCore = true;
  selfRowData: any;
  selfValue: string | number;
  @Output() save: EventEmitter<any> = new EventEmitter();

  constructor(public alertCtrl: AlertController, public actionSheetController: ActionSheetController, 
    private platform: Platform, private translate:TranslateService) {
    this.isCore = this.platform.is('desktop'); // TODOALEX
  }

  @Input() set value(data) {
    this.selfValue = data || '';
    this.renderValue = this.selfValue.toString().toUpperCase();
    this.isButton = this.renderValue === '';
    this.renderValue = this.isButton ? this.translate.instant('Create') : this.translate.instant('Created');
  }

  @Input() set rowData(data) {
    this.selfRowData = data;
    this.visible = this.selfRowData.type === 'Angehöriger';
  }

  // ngOnInit() {
  //     this.visible = this.rowData.type === "Angehöriger";

  //     this.renderValue = this.value.toString().toUpperCase();
  //     this.isButton = this.renderValue === '';
  //     this.renderValue = this.isButton ? 'Anlegen' : 'Angelegt';
  // }

  onClick(action: string) {
    this.save.emit({row: this.selfRowData, action});
  }

  async expandMenu() {
    const actionSheet = await this.actionSheetController.create({
      cssClass: 'contact-data',
      buttons: [{
        text: this.translate.instant('ShowProfile'),
        icon: 'person',
        handler: () => this.onClick('openProfile')
      }, {
        text: this.translate.instant('DeleteLink'),
        icon: 'trash',
        handler: () => this.onClick('removeConnection')
      }, {
        text: this.translate.instant('Cancel'),
        icon: 'close',
        role: 'cancel'
      }]
    });
    actionSheet.present();
  }
}
